import styled from '@emotion/styled';
import React from 'react';
import { config } from 'src/config/config';
import logoImg from 'src/public/img/mh-logo-text.svg';

import { layout, mediaQueries } from 'src/shared/styles/variables';
import backgroundImage from 'src/shared/svg/bg-hero-section-2.svg';

const EapAuthorizationStyledWrapper = styled('div')({
    paddingTop: 130,
    paddingBottom: 50,
    display: 'flex',
    flex: 1,
    height: '100%',
    justifyContent: 'center',
    flexGrow: 1,
    [mediaQueries.sm]: {
        paddingBottom: 30,
    },
});

const InnerWrapperStyled = styled('div')({
    maxWidth: layout.containerBiggerWidth,
    padding: `0 ${layout.containerPaddingX}px`,
    margin: '0 auto',
    [mediaQueries.sm]: {
        padding: '0 15px',
    },
});

interface Props {
    children: React.ReactChild;
    hideBackground?: boolean;
}

const BrandImage = styled.img({
    marginLeft: 30,
    marginTop: 20,
    width: '15em',
    cursor: 'pointer',
    marginRight: 10,
});

export const EapAuthLayout: React.SFC<Props> = props => (
    <div
        style={{
            flex: 1,
            backgroundSize: 'cover',
            backgroundImage: props.hideBackground ? '' : `url('${backgroundImage}')`,
        }}
    >
        <BrandImage
            src={logoImg}
            onClick={() => {
                window.location.href = config.modernHealthURL;
            }}
        />
        <EapAuthorizationStyledWrapper>
            <InnerWrapperStyled>{props.children}</InnerWrapperStyled>
        </EapAuthorizationStyledWrapper>
    </div>
);
